import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import React, { Fragment, useContext, useState } from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { deleteIncome, fetchCommonIncome } from "../../helpers/api/finance";
import { getFinanceModuleBase, isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";
import Filter from "../common/Filter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toast } from "../UI/toast/Toast";
import Swal from "sweetalert2";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import EditIncomeModal from "./EditIncomeModal";

const filter_options = [
  { value: "pending", displayName: "Pendientes (planilla)", disabled: false },
  { value: "issued", displayName: "Emitidos en planilla", disabled: false },
  { value: "cash", displayName: "Caja", disabled: false },
  { value: "reserve_fund", displayName: "Fondo de reserva", disabled: false },
];

const CommonIncome = ({
  setRedirect,
  setRedirectUrl,
  showPagination = true,
}) => {
  const { id } = useParams();
  const location = useLocation();
  const moduleBase = getFinanceModuleBase(location.pathname);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [params, setParams] = useState({
    state: 0,
    condominiumId: id,
    start_date: null,
    end_date: null,
    view: "pending",
  });

  const { currency: curr, loading, baseCurrency } = useContext(CurrencyContext);
  const { currency } = useSelector((state) => state.auth);
  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });
  const {
    data,
    isLoading,
    meta,
    mutate,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchCommonIncome, params);

  const [selectedIncome, setSelectedIncome] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleEdit = (incomeItem) => {
    setSelectedIncome(incomeItem);
    setIsEditModalOpen(true);
  };

  const handleDelete = (incomeId) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Quieres eliminar este ingreso?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#9341af",
      cancelButtonColor: "#bbb",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.value) {
        try {
          const { code } = await deleteIncome(incomeId);
          if (code === "H0004" || code === "H0000" || code === "OK" || code === 200) {
            Toast.fire({
              type: "success",
              title: "Ingreso eliminado exitosamente.",
            });
            mutate();
          }
        } catch (error) {
          handleErrorMessage(error);
        }
      }
    });
  };

  const ButtonAdd = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Añadir ingreso común
      </ButtonIcon>
    );
  };

  const handleCreateCommonIncome = () => {
    setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-income/create`);
    setRedirect(true);
  };

  /*     const renderItems = () => {
        return data.map((aliquot, i) => {
            return <AliquotListItem
                key={aliquot.id}
                amount={aliquot.value}
                name={`${aliquot.property.user.data.firstname} ${aliquot.property.user.data.lastname}`}
                description={aliquot.description}
                handleEdit={() => handleEdit(aliquot.id)}
                createdAt={aliquot.created_at}
                handleDelete={() => handleDelete(aliquot.id)}
                options={true}
            />
        })
    } */

  return (
    <>
      <PageHeader
        title="Ingresos comunes"
        titleTag="h2"
        description="Gestiona y administra cada una de tus finanzas."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card>
        <FalconCardHeader title="Ingresos comunes">
          <Row className="align-items-start">
            <Filter
              keyField="view"
              options={filter_options}
              selectType={setParams}
              dateFilter={true}
            />
            <Col xs="auto" className="mt-2">
              <ButtonAdd onClick={handleCreateCommonIncome} />
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody className={isIterableArray(data) ? "p-0" : ""}>
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            {isIterableArray(data) && data.length > 0 ? (
              <>
                {data.map((cost, index) => (
                  <Fragment key={index}>
                    <Col className=" shadow-none border-top">
                      <Row className="mb-3 mt-3">
                        <Col className="d-flex align-items-center">
                          <div className="media-body">
                            <h6 className="mb-0 font-weight-semi-bold">
                              <span className="text-900">
                                <p className="m-0">{cost.name}</p>
                              </span>
                            </h6>
                            <p className="m-0">{cost.description}</p>
                            <p className="m-0">
                              creada el{" "}
                              {moment(cost.created_at).format("DD-MM-YYYY")}
                            </p>
                            {cost.period?.name && (
                              <Badge className="rounded-capsule badge-soft-success">
                                Emitido en {cost.period.name}
                              </Badge>
                            )}
                          </div>
                        </Col>
                        <Col>
                          <Row>
                            <Col>
                              <p className="text-right">Monto</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <h5 className="text-right">
                                <NumberFormat
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  displayType="text"
                                  value={cost.amount}
                                />
                                <NumberFormat
                                  className="text-right"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={" | " + curr?.currency?.iso + " "}
                                  value={cost.amount * Number(curr?.value || 0)}
                                />
                              </h5>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs="auto" className="d-sm-flex align-items-center">
                          <UncontrolledDropdown
                            direction="left"
                            className="d-inline-block ml-2"
                          >
                            <DropdownToggle color="falcon-default" size="sm">
                              <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu>
                              {!cost.period_id && !cost.period?.name ? (
                                <>
                                  <DropdownItem onClick={() => handleEdit(cost)}>
                                    Editar
                                  </DropdownItem>
                                  <DropdownItem
                                    className="text-danger"
                                    onClick={() => handleDelete(cost.id)}
                                  >
                                    Eliminar
                                  </DropdownItem>
                                </>
                              ) : (
                                <DropdownItem disabled>
                                  Emitido en planilla (no editable)
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>
                  </Fragment>
                ))}
              </>
            ) : (
              <Row className="p-card">
                <Col>
                  <Alert color="info" className="mb-0">
                    Al parecer aún no hay ingresos para mostrar. Puedes crear
                    uno ahora mismo pulsando el siguiente enlace
                    <Button
                      data-testid="Button"
                      tag={Link}
                      color="link"
                      size="sm"
                      className="ml-1 pl-0"
                      to={`/dashboard/${moduleBase}/${selectedCondominium}/common-income/create`}
                    >
                      Crear ingreso común
                    </Button>
                  </Alert>
                </Col>
              </Row>
            )}
            {showPagination && (
              /*      <CardFooter className="border-top"> */
              <FullPagination
                nextPage={nextPage}
                prevPage={previousPage}
                goToPage={goToPage}
                meta={meta}
                className={"shadow-none"}
                posText={"Ingresos comunes"}
                perPage={perPage}
              />
              /*       </CardFooter> */
            )}
          </PreloadState>
        </CardBody>
        {/*         {isIterableArray(data) &&
                <CardFooter>
                    <FullPagination
                        nextPage={nextPage}
                        prevPage={previousPage}
                        goToPage={goToPage}
                        meta={meta}
                        className={'shadow-none'}
                        posText={"cuentas"}
                        perPage={perPage} />
                </CardFooter>
            } */}
      </Card>
      <EditIncomeModal
        isOpen={isEditModalOpen}
        toggle={() => setIsEditModalOpen(!isEditModalOpen)}
        income={selectedIncome}
        condominiumId={selectedCondominium || id}
        onSuccess={() => mutate()}
      />
    </>
  );
};

CommonIncome.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(CommonIncome);
